import React from 'react';
import PropTypes from 'prop-types';

import { UpvoteIcon } from 'components/Icons';
import './ProductQuestionsAndAnswersUpVote.scss';

const ProductQuestionsAndAnswersUpVote = ({ disabled, handleUpVoteClick, upVoteCount }) => (
	<div className="ProductQuestionsAndAnswersUpVote">
		<button
			type="button"
			className="ProductQuestionsAndAnswersUpVote__button"
			onClick={handleUpVoteClick}
			disabled={disabled}
			aria-label={disabled ? 'Question upvoted' : 'Upvote question'}
		>
			<UpvoteIcon height="17px" width="17px" />
		</button>
		<div className="ProductQuestionsAndAnswersUpVote__count">
			{upVoteCount}
		</div>
	</div>
);

ProductQuestionsAndAnswersUpVote.propTypes = {
	disabled: PropTypes.bool,
	handleUpVoteClick: PropTypes.func,
	upVoteCount: PropTypes.number
};

export default ProductQuestionsAndAnswersUpVote;
